import React, { useContext, useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  IconButton,
  useMediaQuery,
  Menu as MuiMenu,
  MenuItem,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from '@mui/material/styles';
import '../css/nav.css';
import '../css/global.css';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import Fade from '@mui/material/Fade';
import LoginModal from '../pages/loginModal';
import { UserContext } from '../assets/contexts/userContext';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import '../css/header.css';

export default function Nav({ formularios, isScrolled, headerBg }) {
  const navigate = useNavigate();
  const { user, changeUser } = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const timeoutRef = useRef();
  const [openLogin, setOpenLogin] = useState(false);
  const theme = useTheme();
  const location = useLocation();
  const scrollContainerRef = useRef(null);
  const [showScrollButtons, setShowScrollButtons] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const staticLinks = [
    { label: 'Inicio', path: '/' },
    { label: 'Cómo ayudamos', path: '/howHelp' },
    { label: 'Quiénes somos', path: '/about' },
    { label: 'Nuestros espacios', path: '/ourSpaces' },
    { label: 'Formaciones', path: '/formaciones' },
    { label: 'Blog', path: '/blog' },
    { label: 'Únete a nosotras', path: '/unete-a-nosotras' },
    { label: 'Pide tu cita', path: '/pide-tu-cita' },
    { label: 'Contáctanos', path: '/contactanos' },
  ];

  const evaluationForms = formularios.filter((f) => f.form_type?.name === 'Evaluación');

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const toggleDrawer = (state) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setOpen(state);
  };

  // const evaluateOverflow = () => {
  //   const container = scrollContainerRef.current;

  //   if (!container || isMobile) {
  //     setShowScrollButtons(false);
  //     return;
  //   }

  //   setShowScrollButtons(container.scrollWidth - container.clientWidth > 1);
  // };
  const updateArrows = () => {
  const el = scrollContainerRef.current;
  if (!el || isMobile) {
    setShowScrollButtons(false);
    setCanScrollLeft(false);
    setCanScrollRight(false);
    return;
  }

  const { scrollLeft, scrollWidth, clientWidth } = el;
  const overflow = scrollWidth - clientWidth > 1;

  setShowScrollButtons(overflow);

  if (!overflow) {
    setCanScrollLeft(false);
    setCanScrollRight(false);
    return;
  }

  const EPS = 2; // margen para evitar parpadeos por redondeos
  setCanScrollLeft(scrollLeft > EPS);
  setCanScrollRight(scrollLeft < (scrollWidth - clientWidth - EPS));
};


  // useEffect(() => {
  //   evaluateOverflow();

  //   const handleResize = () => {
  //     evaluateOverflow();
  //   };

  //   window.addEventListener('resize', handleResize);

  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, [isMobile, formularios.length]);

useEffect(() => {
  updateArrows();
  const onResize = () => updateArrows();

  const el = scrollContainerRef.current;
  const onScroll = () => updateArrows();
  const ro = el ? new ResizeObserver(updateArrows) : null;

  window.addEventListener('resize', onResize);
  if (el) {
    el.addEventListener('scroll', onScroll, { passive: true });
    ro.observe(el);
  }

  return () => {
    window.removeEventListener('resize', onResize);
    if (el) el.removeEventListener('scroll', onScroll);
    if (ro) ro.disconnect();
  };
}, [isMobile, formularios.length]);


  // useEffect(() => {
  //   const timeout = setTimeout(() => {
  //     evaluateOverflow();
  //   }, 0);

  //   return () => clearTimeout(timeout);
  // }, []);

   useEffect(() => {
    const timeout = setTimeout(() => {
      updateArrows();
    }, 0);

    return () => clearTimeout(timeout);
  }, []);

  const scrollMenu = (direction) => {
    const container = scrollContainerRef.current;

    if (!container) {
      return;
    }

    const scrollAmount = container.clientWidth * 0.6;
    container.scrollBy({
      left: direction * scrollAmount,
      behavior: 'smooth',
    });
  };

  const cancelMenuClose = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const handleMenuOpen = (event) => {
    cancelMenuClose();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuToggle = (event) => {
    cancelMenuClose();
    if (menuOpen) {
      setAnchorEl(null);
      return;
    }
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    cancelMenuClose();
    setAnchorEl(null);
  };

  const handleMenuCloseWithDelay = () => {
    cancelMenuClose();
    timeoutRef.current = setTimeout(() => {
      setAnchorEl(null);
      timeoutRef.current = null;
    }, 150);
  };

  const showLogin = () => {
    setOpen(false);
    setOpenLogin(true);
  };

  const navButtonSx = {
    color: 'var(--color-light-beige)',
    borderRadius: '0.3em',
    padding: '0.5em 0.50em',
    display: 'flex',
    justifyContent: isMobile ? 'center' : 'center',
    alignItems: 'center',
    textAlign: isMobile ? 'center !important' : 'center !important',
    width: 'auto',
    minWidth: 'max-content',
    whiteSpace: 'nowrap',
    '&:hover': {
      color: '#66ab5ecf',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      '& .MuiTypography-root': {
        textDecoration: 'underline !important',
        textDecorationColor: '#66ab5ecf',
      },
    },
  };

  const navTypographyStyles = {
    fontSize: isMobile
      ? '1rem !important'
      :  'clamp(1.2rem, 0.45vw, 1.5rem) !important',
    fontWeight: '400 !important',
    fontFamily: "'Nunito', 'Raleway', sans-serif !important",
    textAlign: isMobile ? 'center !important' : 'left !important',
    display: 'inline-block',
  };

  const navIconSx = {
    color: 'inherit !important',
  };

  const activeNavButtonSx = {   
    color: '#66ab5ecf',
    '& .MuiTypography-root': {
      textDecoration: 'underline !important',
      textDecorationColor: '#66ab5ecf',
    },
  };

  const fadePx = 110;

const mask =
  canScrollLeft && canScrollRight
    ? `linear-gradient(to right,
        transparent 0,
        #000 ${fadePx}px,
        #000 calc(100% - ${fadePx}px),
        transparent 100%)`
    : canScrollLeft
    ? `linear-gradient(to right,
        transparent 0,
        #000 ${fadePx}px,
        #000 100%)`
    : canScrollRight
    ? `linear-gradient(to right,
        #000 0,
        #000 calc(100% - ${fadePx}px),
        transparent 100%)`
    : "none";

  const mobileMenu = (
    <>
      <IconButton onClick={toggleDrawer(true)} sx={{ color: 'var(--color-light-beige)', }}>
        <MenuIcon />
      </IconButton>
      <Drawer
        anchor="right"
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{ sx: { backgroundColor: 'rgb(160, 197, 156)' } }}
      >
        <Box sx={{ width: 250 }} role="presentation" onKeyDown={toggleDrawer(false)}>
          <List>
            {staticLinks.map((item) => {
              const isActive =
                item.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(item.path);
              return (
                <ListItem key={item.path} disablePadding>
                  <ListItemButton
                    sx={{ ...navButtonSx, ...(isActive && activeNavButtonSx) }}
                    onClick={() => {
                      navigate(item.path);
                      setOpen(false);
                    }}
                  >
                  <ListItemText
                    primary={item.label}
                    sx={{
                      '& .MuiTypography-root': navTypographyStyles,
                    }}

                  />
                </ListItemButton>
              </ListItem>
              );
            })}
            <ListItem disablePadding>
              <ListItemButton sx={navButtonSx} onClick={handleMenuOpen}>
                <ListItemText
                  primary="Evaluaciones iniciales"
                  sx={{
                    '& .MuiTypography-root': navTypographyStyles,
                  }}
                />
                {menuOpen ? (
                  <KeyboardArrowUpRoundedIcon sx={navIconSx} />
                ) : (
                  <KeyboardArrowDownRoundedIcon sx={navIconSx} />
                )}
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton sx={navButtonSx} onClick={showLogin}>
                <ListItemText
                  primary="Acceso"
                  sx={{
                    '& .MuiTypography-root': navTypographyStyles,
                  }}
                />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </>
  );

 

 const desktopMenu = (
  <Box component="nav" aria-label="Main Navigation" sx={{ width: "100%", minWidth: 0 }}>
    <Box sx={{ position: "relative", width: "100%", height: "100%" }}>

      {/* ✅ Degradado: solo cuando hay más contenido oculto */}
      {showScrollButtons && canScrollLeft && (
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: "110px",
            zIndex: 1,
            pointerEvents: "none",
          //  background: "linear-gradient(to right, var(--header-bg) 35%, transparent 100%)",

          }}
        />
      )}

      {showScrollButtons && canScrollRight && (
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            bottom: 0,
            width: "110px",
            zIndex: 1,
            pointerEvents: "none",
            // background: "linear-gradient(to left, var(--header-bg) 35%, transparent 100%)",
          }}
        />
      )}

      <IconButton
        aria-label="Desplazar menú hacia la izquierda"
        onClick={() => scrollMenu(-1)}
        disabled={!showScrollButtons || !canScrollLeft}
        sx={{
          display: showScrollButtons ? "flex" : "none",
          position: "absolute",
          left: 4,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 2,
          color: "var(--color-light-beige)",
          backgroundColor: "transparent",
          opacity: canScrollLeft ? 1 : 0.4,
          pointerEvents: canScrollLeft ? "auto" : "none",
          cursor: 'pointer',
          "&:hover": { backgroundColor: "rgba(102, 171, 94, 0.4)" },
        }}
      >
        <ChevronLeftIcon />
      </IconButton>

      <Box
        ref={scrollContainerRef}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "ArrowLeft" && canScrollLeft) scrollMenu(-1);
          if (e.key === "ArrowRight" && canScrollRight) scrollMenu(1);
        }}
      
        sx={{
          overflowX: "auto",
          overflowY: "hidden",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
          display: "flex",
          justifyContent: showScrollButtons ? "flex-start" : "center",  
          /* ✅ espacio para que el texto no pase bajo las flechas */
          pl: showScrollButtons ? 8 : 0,
          pr: showScrollButtons ? 8 : 0,

          /* ✅ el fade “borra” el contenido del menú */
          WebkitMaskImage: mask,
          maskImage: mask,
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskSize: "100% 100%",
          maskSize: "100% 100%",
        }}
      >
        <List
          sx={{
            display: "inline-flex",
            flexWrap: "nowrap",
            justifyContent: "flex-start",
            gap: "clamp(0.25rem, 0.9vw, 0.3rem)",
            width: "max-content",
            minWidth: "max-content",
            p: 0,
          }}
        >
            {staticLinks.map((item) => {
              const isActive =
                item.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(item.path);
              return (
                <ListItem
                  key={item.path}
                  className="nav-list-item"
                  disablePadding
                  sx={{ flex: '0 0 auto', width: 'auto' }}
                >
                  <ListItemButton
                    className="nav-list-item-button"
                    onClick={() => navigate(item.path)}
                    sx={{ ...navButtonSx, ...(isActive && activeNavButtonSx) }}
                  >
                    <ListItemText
                      primary={item.label}
                      sx={{
                        '& .MuiTypography-root': navTypographyStyles,
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              );
            })}
            <ListItem disablePadding sx={{ flex: '0 0 auto', width: 'auto' }}>
              <ListItemButton
                className="nav-list-item-button"
                onClick={handleMenuToggle}
                aria-haspopup="true"
                aria-expanded={menuOpen ? 'true' : undefined}
                aria-controls={menuOpen ? 'nav-evaluaciones-menu' : undefined}
                sx={{ ...navButtonSx, ...(menuOpen && activeNavButtonSx) }}
              >
                <ListItemText
                  primary="Evaluaciones iniciales"
                  sx={{
                    '& .MuiTypography-root': navTypographyStyles,
                  }}
                />
                {menuOpen ? (
                  <KeyboardArrowUpRoundedIcon sx={navIconSx} />
                ) : (
                  <KeyboardArrowDownRoundedIcon sx={navIconSx} />
                )}
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding sx={{ flex: '0 0 auto', width: 'auto' }}>
              <ListItemButton
                className="nav-list-item-button"
                onClick={showLogin}
                sx={navButtonSx}
              >
                <ListItemText
                  primary="Acceso"
                  sx={{
                    '& .MuiTypography-root': navTypographyStyles,
                  }}
                />
              </ListItemButton>
            </ListItem>
          </List>
      </Box>

      <IconButton
        aria-label="Desplazar menú hacia la derecha"
        onClick={() => scrollMenu(1)}
        disabled={!showScrollButtons || !canScrollRight}
        sx={{
          display: showScrollButtons ? "flex" : "none",
          position: "absolute",
          right: 4,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 2,
          color: "var(--color-light-beige)",
          backgroundColor: "transparent",
          opacity: canScrollRight ? 1 : 0.4,
          pointerEvents: canScrollRight ? "auto" : "none",
          cursor: 'pointer',
          "&:hover": { backgroundColor: "rgba(102, 171, 94, 0.4)" },
        }}
      >
        <ChevronRightIcon />
      </IconButton>
    </Box>
  </Box>
);


  const evaluationMenu = (
    <MuiMenu
      slotProps={{
        paper: {
          sx: {
            backgroundColor: 'rgb(160, 197, 156)',
            mt: isMobile ? 0 : '0.3em',
          },
          onMouseEnter: cancelMenuClose,
          onMouseLeave: handleMenuCloseWithDelay,
        },
      }}
      TransitionComponent={Fade}
      TransitionProps={{
        timeout: {
          enter: 300,
          exit: 600,
        },
      }}
      anchorEl={anchorEl}
      open={menuOpen}
      onClose={handleMenuClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      MenuListProps={{
        id: 'nav-evaluaciones-menu',
        autoFocusItem: false,
        onMouseEnter: cancelMenuClose,
        onMouseLeave: handleMenuCloseWithDelay,
      }}
    >
      {evaluationForms.map((form) => (
        <MenuItem
          key={form.id}
          onClick={() => {
            navigate(`/form/${form.slug}`);
            handleMenuClose();
            setOpen(false);
          }}
          sx={{
            color: 'var(--color-light-beige)',
            backgroundColor: 'rgb(160, 197, 156)',
            fontSize: isMobile
            ? '1rem !important'
            :  'clamp(1rem, 0.45vw + 0.7rem, 1.3rem) !important',
            fontWeight: '400 !important',
            fontFamily: "'Nunito', 'Raleway', sans-serif !important",
            borderRadius: '0.3em',
            padding: '0.5em 0.5em',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            textAlign: 'left',
            width: 'auto',
            minWidth: 'fit-content',
            whiteSpace: 'nowrap',
            '&:hover': {
              color: '#66ab5ecf',
              textDecoration: 'none',
              backgroundColor: 'rgba(255, 250, 214, 0.42)',
              cursor: 'pointer',
            },
          }}
        >
          {form.nombre}
        </MenuItem>
      ))}
    </MuiMenu>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: isMobile ? 'flex-end' : 'center',
        alignItems: 'center',
        // marginRight: isMobile ? '0.8em' : '1.5em',
        // marginLeft: isMobile ? '0' : '1em',
        marginRight: 0,
        marginLeft: 0,
        fontFamily: 'Nunito, Raleway, sans-serif',
        fontSize: isMobile ? '1em' : '1.25em',
        width: '100%',
        flexGrow: 1,
        minWidth: 0,
      }}
    >
      {isMobile ? mobileMenu : desktopMenu}
      {evaluationMenu}
      <LoginModal open={openLogin} onClose={() => setOpenLogin(false)} showLogin={() => setOpenLogin(true)} />
    </Box>
  );
}
